import Cookies from "js-cookie";
import * as config from "../config";

export function aanpAuthOptions() {
  const impersonatingContactId = localStorage.getItem(
    config.storageKeys.impersonatingContactId
  );
  return {
    headers: {
      "Aanp-Token": Cookies.get(config.storageKeys.authToken),
      "Impersonating-ContactId":
        impersonatingContactId !== null ? impersonatingContactId : "",
      "Content-Type": "application/json",
    },
  };
}

export function groupBy(list, props) {
  return list.reduce((a, b) => {
    (a[b[props]] = a[b[props]] || []).push(b);
    return a;
  }, {});
}
